import { crmParamDetail } from './crmParamReducer';

export const crm_param_action = (query) => async (dispatch) => {
    try {
        dispatch(crmParamDetail(query));
    } catch (err) {
        const error = {
            code: 0,
            message: typeof err == 'object' ? err.message : err,
        };
        throw error;
    }
};